<div class="container-fluid" *ngIf="workflow as wf">
  <div class="panel workflow-header-card">
    <div class="workflow-header-top">
      <div class="wf-os-title">
        <div class="wf-os-label">Ordem de Servico</div>
        <div class="wf-os-number">{{ getOsNumero(wf) }}</div>
      </div>
      <span
        class="status-badge"
        [class.status-em-andamento]="wf.statusGeral === 'EM_ANDAMENTO'"
        [class.status-atrasado]="wf.statusGeral === 'ATRASADO'"
        [class.status-concluido]="wf.statusGeral === 'CONCLUIDO'"
      >
        {{
          wf.statusGeral === 'EM_ANDAMENTO'
            ? 'EM ANDAMENTO'
            : wf.statusGeral === 'ATRASADO'
              ? 'ATRASADO'
              : 'CONCLUIDO'
        }}
      </span>
    </div>
    <div class="detail-section">
      <div class="section-title">Cliente</div>
      <div class="info-grid">
        <div class="info-item">
          <div class="info-label">Nome</div>
          <div class="info-value">{{ wf.clienteNome || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Telefone</div>
          <div class="info-value">{{ wf.clienteTelefone || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Email</div>
          <div class="info-value">{{ wf.clienteEmail || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Consultor</div>
          <div class="info-value">{{ wf.consultorResponsavel || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Seguradora</div>
          <div class="info-value">{{ wf.seguradoraNome || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Sinistro</div>
          <div class="info-value">{{ wf.sinistroNumero || '—' }}</div>
        </div>
      </div>
    </div>

    <div class="detail-section">
      <div class="section-title">Veículo</div>
      <div class="info-grid">
        <div class="info-item">
          <div class="info-label">Placa</div>
          <div class="info-value">{{ wf.placa || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Marca</div>
          <div class="info-value">{{ wf.marca || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Modelo</div>
          <div class="info-value">{{ wf.modelo || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Número OS</div>
          <div class="info-value">{{ wf.osNumero || 'OS-' + ('' + wf.id).padStart(6, '0') }}</div>
        </div>
      </div>
    </div>

    <div class="detail-section">
      <div class="section-title">Outros dados</div>
      <div class="info-grid">
        <div class="info-item">
          <div class="info-label">Responsável atual</div>
          <div class="info-value">{{ wf.responsavelAtual || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Etapa atual</div>
          <div class="info-value">{{ etapaAtual?.nome || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Status</div>
          <div class="info-value">
            {{
              wf.statusGeral === 'EM_ANDAMENTO'
                ? 'Em andamento'
                : wf.statusGeral === 'ATRASADO'
                  ? 'Atrasado'
                  : 'Conclu—do'
            }}
          </div>
        </div>
        <div class="info-item">
          <div class="info-label">Fase</div>
          <div class="info-value">{{ wf.fase || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Dias na etapa</div>
          <div class="info-value">{{ wf.diasNaEtapaAtual ?? '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Atraso (dias)</div>
          <div class="info-value">{{ wf.atrasoDias ?? '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Último contato</div>
          <div class="info-value">
            {{ wf.ultimoContatoEm ? (wf.ultimoContatoEm | date: 'dd/MM/yyyy') : '—' }}
          </div>
        </div>
        <div class="info-item">
          <div class="info-label">Próximo contato</div>
          <div class="info-value">
            {{ wf.proximoContatoEm ? (wf.proximoContatoEm | date: 'dd/MM/yyyy') : '—' }}
          </div>
        </div>
        <div class="info-item">
          <div class="info-label">Observação</div>
          <div class="info-value">{{ etapaAtual?.observacoes?.[0] || '—' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Data início</div>
          <div class="info-value">
            {{ getDataInicio(wf) ? (getDataInicio(wf) | date: 'dd/MM/yyyy') : '—' }}
          </div>
        </div>
        <div class="info-item">
          <div class="info-label">Data final prevista</div>
          <div class="info-value">
            {{ getDataFinalPrevista(wf) ? (getDataFinalPrevista(wf) | date: 'dd/MM/yyyy') : '—' }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-1">
    <div class="col-12">
      <div class="panel">
        <div class="tabs-pill" role="tablist">
          <button
            type="button"
            class="tab-btn"
            [class.active]="activeTab === 'status'"
            (click)="setTab('status')"
          >
            Status
          </button>
          <button
            type="button"
            class="tab-btn"
            [class.active]="activeTab === 'historico'"
            (click)="setTab('historico')"
          >
            Historico
          </button>
          <button
            type="button"
            class="tab-btn"
            [class.active]="activeTab === 'anexos'"
            (click)="setTab('anexos')"
          >
            Anexos
          </button>
          <button
            type="button"
            class="tab-btn"
            [class.active]="activeTab === 'comunicacao'"
            (click)="setTab('comunicacao')"
          >
            Comunicacao
          </button>
          <button
            type="button"
            class="tab-btn"
            [class.active]="activeTab === 'comentarios'"
            (click)="setTab('comentarios')"
          >
            Comentarios
          </button>
        </div>

        <div class="pt-3" *ngIf="activeTab === 'status'">
          <div class="timeline-split">
            <div class="timeline-left">
              <div class="steps">
                <div
                  class="step"
                  *ngFor="let step of stepDefinitions; let i = index"
                  [class.step--done]="isStepDone(i, step.tipo)"
                  [class.step--current]="isStepCurrent(i)"
                  [class.step--todo]="isStepTodo(i, step.tipo)"
                  [class.step--selected]="step.tipo === selectedStepTipo"
                  (click)="selectStep(step.tipo)"
                >
                  <div class="step-marker">
                    <div class="step-circle">{{ i + 1 }}</div>
                  </div>
                  <div class="step-content">
                    <div class="step-title">
                      {{ step.label }}
                      <span class="step-badge" *ngIf="isStepCurrent(i)">ATUAL</span>
                    </div>
                    <div class="step-meta" *ngIf="getEtapaFor(step.tipo)?.inicio">
                      Inicio: {{ getEtapaFor(step.tipo)?.inicio | date: 'dd/MM HH:mm' }}
                    </div>
                    <div class="step-meta" *ngIf="getEtapaFor(step.tipo)?.fim">
                      Fim: {{ getEtapaFor(step.tipo)?.fim | date: 'dd/MM HH:mm' }}
                    </div>
                    <div class="step-meta">
                      Responsavel: {{ getEtapaFor(step.tipo)?.responsavel || '—' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="timeline-right">
              <div class="step-detail">
                <div class="step-detail__header">
                  <div class="step-detail__title">{{ selectedStepLabel }}</div>
                </div>
                <div class="late-alert" *ngIf="isSelectedLate">
                  <div class="late-icon">!</div>
                  <div class="late-text">
                    <div class="late-title">ETAPA EM ATRASO</div>
                    <div class="late-subtitle">Atenção: esta etapa está fora do prazo.</div>
                  </div>
                </div>

                <div class="step-detail__grid">
                  <div class="step-field">
                    <div class="step-field__label">Data Prevista de Início</div>
                    <div class="step-field__value">
                      {{
                        selectedPlannedInicio ? (selectedPlannedInicio | date: 'dd/MM/yyyy') : '—'
                      }}
                    </div>
                  </div>
                  <div class="step-field">
                    <div class="step-field__label">Data Prevista de Fim</div>
                    <div class="step-field__value">
                      {{ selectedPlannedFim ? (selectedPlannedFim | date: 'dd/MM/yyyy') : '—' }}
                    </div>
                  </div>
                  <div class="step-field">
                    <div class="step-field__label">Data Real de Início</div>
                    <div class="step-field__value">
                      {{ selectedRealInicio ? (selectedRealInicio | date: 'dd/MM/yyyy') : '—' }}
                    </div>
                  </div>
                  <div class="step-field">
                    <div class="step-field__label">Data Real de Fim</div>
                    <div class="step-field__value">
                      {{ selectedRealFim ? (selectedRealFim | date: 'dd/MM/yyyy') : '—' }}
                    </div>
                  </div>
                  <div class="step-field">
                    <div class="step-field__label">Nome do Responsável</div>
                    <div class="step-field__value">{{ selectedResponsavel }}</div>
                  </div>
                </div>

                <div class="timeline-divider"></div>

                <div class="step-section">
                  <div class="step-section__title">
                    {{ isCompraPecasSelected ? 'Peças para compra' : 'Checklist' }}
                  </div>
                  <ng-container *ngIf="isCompraPecasSelected; else checklistDefault">
                    <div class="wf-table-card">
                      <table class="wf-table">
                        <thead>
                          <tr>
                            <th>Código</th>
                            <th>Descrição</th>
                            <th>Quantidade</th>
                            <th>Quantidade Compra</th>
                            <th>Data Solicitação</th>
                            <th>Data Prevista</th>
                            <th>Dias</th>
                            <th>Status</th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of pecasCompra">
                            <td>{{ item.codigo }}</td>
                            <td>{{ item.descricao }}</td>
                            <td>{{ item.quantidade }}</td>
                            <td>{{ item.quantidadeCompra }}</td>
                            <td>{{ item.dataSolicitacao | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ item.dataPrevista | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ getDiasDesde(item.dataSolicitacao) }}</td>
                            <td>
                              <span class="status-text">
                                <span
                                  class="status-dot"
                                  [class.status-dot--green]="item.status === 'Recebida'"
                                  [class.status-dot--red]="item.status === 'Atrasada'"
                                  [class.status-dot--gray]="item.status === 'Aguardando'"
                                ></span>
                                {{ item.status }}
                              </span>
                            </td>
                            <td>
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                (click)="openPecaComentario(item)"
                              >
                                <svg
                                  class="icon-comment"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4 5.5C4 4.11929 5.11929 3 6.5 3H17.5C18.8807 3 20 4.11929 20 5.5V14.5C20 15.8807 18.8807 17 17.5 17H10.2L6 20.5V17H6.5C5.11929 17 4 15.8807 4 14.5V5.5Z"
                                    stroke="currentColor"
                                    stroke-width="1.6"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M7.5 8.5H16.5M7.5 11.5H13.5"
                                    stroke="currentColor"
                                    stroke-width="1.6"
                                    stroke-linecap="round"
                                  />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ng-container>
                  <ng-template #checklistDefault>
                    <div
                      class="step-checklist"
                      *ngIf="selectedChecklistItems.length; else noChecklist"
                    >
                      <label
                        class="checklist-item"
                        *ngFor="let item of selectedChecklistItems; let idx = index"
                      >
                        <input type="checkbox" [(ngModel)]="selectedChecklistState[idx]" />
                        <span>{{ item }}</span>
                      </label>
                    </div>
                    <ng-template #noChecklist>
                      <div class="text-muted">Sem checklist para esta etapa.</div>
                    </ng-template>
                  </ng-template>
                </div>

                <div class="timeline-divider"></div>

                <div class="step-section">
                  <div class="step-section__title">Anexos</div>
                  <input
                    class="form-control"
                    type="file"
                    multiple
                    (change)="onFilesSelected($event)"
                  />
                  <div class="step-files" *ngIf="selectedFiles.length">
                    <div class="step-file" *ngFor="let file of selectedFiles">{{ file.name }}</div>
                  </div>
                </div>

                <div class="timeline-divider"></div>

                <div class="step-section">
                  <div class="step-section__title">Comentário</div>
                  <textarea
                    class="form-control"
                    rows="3"
                    [(ngModel)]="commentsByStep[selectedStepLabel]"
                  ></textarea>
                </div>

                <div class="step-actions">
                  <button class="btn btn-primary" type="button" (click)="markStepDone()">
                    Adicionar comentário
                  </button>
                  <button
                    class="btn btn-success"
                    style="margin-left: 3px"
                    type="button"
                    (click)="markStepDone()"
                  >
                    Etapa finalizada
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-3" *ngIf="activeTab === 'historico'">
          <div class="table-wrap">
            <app-history-table [historico]="wf.historico"></app-history-table>
          </div>
        </div>
        <div class="pt-3" *ngIf="activeTab === 'anexos'">
          <div class="table-wrap">
            <app-upload-list [anexos]="anexosTodos"></app-upload-list>
          </div>
        </div>
        <div class="pt-3" *ngIf="activeTab === 'comunicacao'">
          <div class="table-wrap">
            <app-communication-list [comunicacoes]="wf.comunicacoes"></app-communication-list>
          </div>
        </div>
        <div class="pt-3" *ngIf="activeTab === 'comentarios'">
          <div class="table-wrap">
            <div class="wf-table-card">
              <table class="wf-table">
                <thead>
                  <tr>
                    <th class="col-date">Data</th>
                    <th class="col-user">Usuario</th>
                    <th class="col-comment">Comentario</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let comentario of comentarios">
                    <td class="col-date">{{ comentario.data | date: 'dd/MM/yyyy' }}</td>
                    <td class="col-user">{{ comentario.usuario }}</td>
                    <td class="col-comment">{{ comentario.comentario }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="text-muted" *ngIf="!workflow">Carregando workflow...</div>

<div class="modal-backdrop-local" *ngIf="isPecaComentarioModalOpen"></div>
<div class="modal-local" *ngIf="isPecaComentarioModalOpen">
  <div class="modal-local__header">
    <div class="modal-local__title">Comentário da peça</div>
  </div>
  <textarea class="form-control" rows="4" [(ngModel)]="pecaComentarioTexto"></textarea>
  <div class="modal-local__actions">
    <button type="button" class="btn btn-outline-secondary" (click)="closePecaComentario()">
      Cancelar
    </button>
    <button type="button" class="btn btn-primary" (click)="savePecaComentario()">Salvar</button>
  </div>
</div>
